import React, { FC, useEffect, useState } from 'react';
import ReactDom from 'react-dom';
import { ListFilterListSearchButton } from './ListFilterListSearchButton';
import { getPortalContainer } from './utils';
import { isNull } from '../../../../predicates/type';
import { syncManager } from '../../../../utils/syncManager/index';

const ListFilterListSearchTextboxPortal: FC<React.PropsWithChildren> = ({ children }) => {
	const [portalContainer, setPortalContainer] = useState<HTMLDivElement | null>(
		getPortalContainer('.listPageHeaderSearch'),
	);

	useEffect(() => {
		syncManager.on('react', 'onListPageHeaderSearchPortalContainerRender', () => {
			const el = getPortalContainer('.listPageHeaderSearch');

			if (isNull(el)) {
				return;
			}

			setPortalContainer(el);
		});

		return () => {
			syncManager.off('react', 'onListPageHeaderSearchPortalContainerRender');
		};
	}, [portalContainer]);

	return portalContainer && ReactDom.createPortal(children, portalContainer);
};

const ListFilterListSearchButtonPortal = ({ disabled }: { disabled?: boolean }) => {
	const [portalContainer, setPortalContainer] = useState<HTMLDivElement | null>(
		getPortalContainer('.listPageHeaderMobileSearchButton'),
	);

	useEffect(() => {
		syncManager.on('react', 'onMobileSearchButtonPortalContainerRender', () => {
			const el = getPortalContainer('.listPageHeaderMobileSearchButton');

			if (isNull(el)) {
				return;
			}

			setPortalContainer(el);
		});

		return () => {
			syncManager.off('react', 'onMobileSearchButtonPortalContainerRender');
		};
	}, [portalContainer]);

	return (
		portalContainer && ReactDom.createPortal(<ListFilterListSearchButton disabled={disabled} />, portalContainer)
	);
};

type ListFilterListSearchPortalProps = {
	searchButtonDisabled?: boolean;
};

export const ListFilterListSearchPortal: FC<React.PropsWithChildren<ListFilterListSearchPortalProps>> = ({
	children,
	searchButtonDisabled,
}) => (
	<React.Fragment>
		<ListFilterListSearchTextboxPortal>{children}</ListFilterListSearchTextboxPortal>
		<ListFilterListSearchButtonPortal disabled={searchButtonDisabled} />
	</React.Fragment>
);
